const modalUpgradeConfig = {
    title: {
        default: 'Upgrade to Pro for the full set of presets and tools',
        trial: 'Start your Pro membership with a 7 day free trial',
    },
    buttons: {
        yearly: 'Per Year',
        monthly: 'Per Month',
    },
    disclaimers: {
        plus: 'Your payment for Plus will be credited towards this purchase',
        transactions: 'Web transactions are currently for U.S. customers only',
        monthly: 'billed monthly',
        yearly: 'billed annually',
    },
};
export default modalUpgradeConfig;
